export default function isValidEmail(email) {
  const res = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email ? res.test(email.trim()) : false;
}
